(function () {
  function clamp(value, min, max) {
    return Math.min(max, Math.max(min, value));
  }

  function renderBar(bar) {
    const track = bar.querySelector('.free-shipping-bar__track');
    const fill = bar.querySelector('.free-shipping-bar__fill');
    if (!track || !fill) return;

    const total = Number(bar.dataset.total || 0);
    const target = Number(bar.dataset.target || 0);
    if (!target) return;

    const percent = clamp((total / target) * 100, 0, 100);
    const isMet = total >= target;
    const color = isMet ? bar.dataset.colorMet : bar.dataset.colorUnder;

    fill.style.width = `${percent}%`;
    if (color) fill.style.backgroundColor = color;
    track.setAttribute('aria-valuenow', String(clamp(total, 0, target)));
  }

  function initFreeShippingBars() {
    document.querySelectorAll('[data-free-shipping-bar]').forEach(renderBar);
  }

  document.addEventListener('DOMContentLoaded', initFreeShippingBars);
  document.addEventListener('shopify:section:load', initFreeShippingBars);
})();
